import { useState } from 'react';
import axios from 'axios';
import { API_STATUS } from '../utils/constants';
import { toastWarn } from '../utils/toasts';

export function useDistribute() {
   const [distributeResponseData, setDistributeResponseData] = useState(null);
   const [distributeStatus, setDistributeStatus] = useState(
      API_STATUS.IN_PROGRESS
   );

   const distributeApi = async (payload, url) => {
      try {
         const response = await axios.post(url, payload, {
            headers: {
               'content-type': 'application/json',
            },
         });

         if (response.status !== 200) {
            toastWarn(response.data.message);
            setDistributeResponseData([]);
            setDistributeStatus(API_STATUS.FAILED);
         } else {
            setDistributeResponseData(response?.data);
            setDistributeStatus(API_STATUS.COMPLETED);
         }
      } catch (error) {
         console.warn('Error in Distribute records', error);
         setDistributeResponseData([]);
         setDistributeStatus(API_STATUS.FAILED);
         toastWarn(error.message);
      }
   };

   return { distributeResponseData, distributeStatus, distributeApi };
}
